import { createContentPropTypes } from '../../helpers/content';

export const deadlineMissedContent = {
	paymentDeadlineMissedTitle: 'Payment date changed',
	deadlineMissedTitle: 'Bacs deadline missed',
	deadlineMissedBacsCreditBody:
		'As this payment’s being authorised after 5.10pm, it’ll now be submitted and settled on the following dates:',
	deadlineMissedBacsDebitBody:
		'As this payment’s being authorised after 5.10pm, it’ll now be submitted and collected on the following dates:',
	deadlineMissedPaymentBody:
		'As you’re authorising this payment after the planned payment date, it will now be submitted and settled on the following dates:',
	deadlineMissedAcceptButton: 'Accept and authorise',
	deadlineMissedCancelPaymentButton: 'Cancel payment',
	deadlineMissedBacsCreditSettlementDateLabel: 'Settlement date:',
	deadlineMissedBacsDebitSettlementDateLabel: 'Collection date:',
	deadlineMissedBacsSubmissionDateLabel: 'Submission date:',

	chapsTitle: 'CHAPS deadline missed',
	chapsBody:
		"As you're authorising this payment after 5pm on the planned payment date, it'll now be submitted for processing by CHAPS on the next available working day.",
	chapsSettlementDateLabel: 'Settlement date:',
	newSubmissionDateLabel: 'New submission date:',
	earlierSettlementDateLabel: 'Earliest estimated settlement date:',
};

export const contentPropTypes = createContentPropTypes(deadlineMissedContent);
